import React, { useEffect, useState } from "react";
import CardFormSecureInvs from "./cardFornSecureInvs";
import Loading from "../Components/loading";
import { awsApiCotizacionRG } from "../Services/AwsService";
import ModalGenerateSimulacion from "./modalGenerateSimulacion";
import { useDispatch, useSelector } from "react-redux";
import { addRecommended } from "../Store/recommended/actions";
import {
  sendDataForPdf,
  cleanTablePdf,
  cleanTablePdfVAS,
  cleanTablePdfIG,
} from "../Store/secureInvestmentIncome/actions";
import { ToastContainer } from "react-toastify";
import FormRgHook from "./formRgHook";
import { decryptEstandar } from "../Utils/CryptographyUtils";
import { removeAll, removeAssured } from "../Store/data/actions";
import { callToAPIQuote } from "../Utils/validators";
import ModalRetakeAsessory from "../Components/modalRetakeAsessory";
import IconAtomsClose from "../Resources/svg/Icons/IconAtomsClose";

function validateValues({ valuesPdf }) {
  if (valuesPdf.length === 0) {
    return true;
  }

  if (valuesPdf.length > 9) {
    return false;
  }

  return true;
}

async function handlerDataApi({
  request,
  userLogin,
  dispatch,
  values,
  assured,
  contratant,
}) {
  return callToAPIQuote({
    values,
    request,
    active: true,
    onDispatch: (resData) => {
      resData.assured = assured;
      resData.contratant = contratant;
      dispatch(sendDataForPdf(resData));
    },
    userLogin,
    dispatch,
  });
}

export default function ModalFormRG({
  dataState,
  close,
  open,
  id_product,
  idProspecto,
  investmentProfile,
  uuid,
}) {
  const [state, setState] = useState({
    items: {},
    openTablePdf: false,
  });
  const [isLoading, setisLoading] = useState(false);
  const [isClear, setIsClear] = useState(false);
  const [alertRG, setAlertRG] = useState(false);
  const [apiErrorMessage, setApiErrorMessage] = useState("");
  const store = useSelector((state) => state.data);
  const valuesPdf = useSelector((state) => state.cotizador.valuesPdf);
  const idUser = useSelector((state) => decryptEstandar(state.login.idClient));
  const userLogin = useSelector((state) =>
    decryptEstandar(state.login.username)
  );
  const portafolio = useSelector((state) => state.cotizador.portafolio);
  const dispatch = useDispatch();
  const [openModalMessage, setOpenModalMessage] = useState(false);
  const activeBtn = useSelector((state) => state.cotizador.btnPdf);
  const closeModal = () => {
    close(id_product);
    setState((prevState) => ({
      ...prevState,
      showSimulate: true,
    }));
    setApiErrorMessage("");
  };

  const openModalPdf = () =>
    setState((prevState) => ({ ...prevState, openTablePdf: true }));
  const onCloseModalPdf = () =>
    setState((prevState) => ({ ...prevState, openTablePdf: false }));

  const { items, openTablePdf } = state;

  let validate = validateValues({ valuesPdf });
  const verifyValuesInPdf = async (values) => {
    if (validate) {
      await getDataMacroExcel(values);
    }
  };

  const getDataMacroExcel = async (values) => {
    setisLoading(true);
    setApiErrorMessage("");

    setState((prevState) => ({
      ...prevState,
      items: {},
      tableSimulate: [],
    }));

    const { assured, contratant, repLegal } = store;

    let request = awsApiCotizacionRG(
      {
        ...values,
        ...assured,
        idProspecto,
        idUser,
      },
      assured,
      contratant,
      repLegal,
      uuid
    );
    const { error, resData, errorMessage } = await handlerDataApi({
      request,
      userLogin,
      dispatch,
      values,
      portafolio,
      assured,
      contratant,
    });
    // -> resData 🏈 {}
    // -> modalFormRG.jsx:135 error ❌ true
   
    // if (error || Object.keys(resData).length === 0)
    if (!error) {
      setState((prevState) => ({ ...prevState, items: resData }));
      setApiErrorMessage("");
    } else {
      setApiErrorMessage(errorMessage || "");
    }

    setisLoading(false);
  };

  const handleClear = () => {
    setOpenModalMessage(true);
  };

  const handleOpen = () => {
    setOpenModalMessage(false);
    closeModal();
    setIsClear(true);
    dispatch(addRecommended({}));
    dispatch(cleanTablePdfVAS());
    dispatch(cleanTablePdf());
    dispatch(cleanTablePdfIG());
  };

  const handleClose = () => {
    setOpenModalMessage(false);
  };

  const cleanPdf = () => {
    dispatch(cleanTablePdf());
  };

  useEffect(() => {
    if (open) {
      document.getElementsByTagName("body")[0].style.overflow = "hidden";
    } else {
      document.getElementsByTagName("body")[0].style.overflow = "auto";
    }
    if (isClear && Object.keys(dataState).length > 1) {
      dispatch(removeAll());
    } else if (isClear && Object.keys(dataState).length === 1) {
      dispatch(removeAssured());
    }
    if (validate) {
      setAlertRG(false);
    } else {
      setAlertRG(true);
    }
  }, [open, isClear, validate]);

  const [modalDataIG, setModalDataIG] = useState({
    items: {},
    openTablePdf: false,
    showSimulate: true,
    tableSimulate: [],
    idQuote: "",
    idComponent: null,
  });

  return (
    <div className={`modalFormRG  ${open ? "is-open" : ""}`}>
      <div className="modalFormRG__container">
        <div className="modalFormRG__container__button" onClick={closeModal}>
          <span>Cerrar</span>
          <IconAtomsClose />
        </div>
        <FormRgHook
          dataState={dataState}
          submitValues={verifyValuesInPdf}
          items={valuesPdf}
          openModalPdf={openModalPdf}
          cleanTablePdf={cleanTablePdf}
          onClick={() => handleClear()}
          investmentProfile={investmentProfile}
          isError={alertRG}
          apiError={apiErrorMessage}
          setState={setModalDataIG}
        />
        <ModalGenerateSimulacion
          open={openTablePdf}
          onCloseModalPdf={onCloseModalPdf}
          cleanTablePdf={cleanPdf}
          items={valuesPdf}
          activeBtn={activeBtn}
          id_product={id_product}
        />
        <CardFormSecureInvs items={items} openModalPdf={openModalPdf} />
        <ToastContainer containerId={"A"} />
      </div>
      {isLoading && <Loading loading={isLoading} />}
      <ModalRetakeAsessory
        open={openModalMessage}
        setOpen={setOpenModalMessage}
        title="¿Estas seguro?"
        subtitleMessage="Al limpiar datos perderás las cotizaciones que generaste."
        messageAlert="Si quieres volver a cotizar deberás ingresar nuevamente el número de DNI de tu cliente; la plataforma solo guardará su perfil de inversión."
        firstButtonText="CANCELAR"
        secondButtonText="CONFIRMAR"
        firstButtonFunction={handleClose}
        secondButtonFunction={handleOpen}
      />
    </div>
  );
}
